import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BasicInformationPage } from './basic-information.page';

const routes: Routes = [
  {
    path: '',
    component: BasicInformationPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BasicInformationRoutingModule {}
